// extracted by mini-css-extract-plugin
module.exports = {"detail":"detail--2FXdensJf","changed":"changed--3bVbYOFRb"};